export const ROLE_STUDENT = "Estudiante";
export const ROLE_ADMINISTRATIVE_ID = 1;
export const ROLE_ATTORNEY_ID = 2;
export const ROLE_TEACHER_ID = 4;
export const ROLE_HOLDER_ID = 5;
export const ROLE_ADMIN_ID = 6;
export const ROLE_DEVELOPER_ID = 7;
